import script from "./ContactsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactsList.vue?vue&type=script&lang=ts&setup=true"

import "./ContactsList.vue?vue&type=style&index=0&id=74e559b5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e559b5"]])

export default __exports__